import { fetchContactAssociations } from "../../profile/actions/golfer-associations-fetch";

export const GOLFER_PROFILE_FETCH = "GOLFER_PROFILE_FETCH";
export const GOLFER_PROFILE_FETCH_FAILED = "GOLFER_PROFILE_FETCH_FAILED";
export const GOLFER_PROFILE_FETCH_SUCCESS = "GOLFER_PROFILE_FETCH_SUCCESS";
export const GOLFER_PROFILE_LOGOUT = "GOLFER_PROFILE_LOGOUT";
export const APPEND_LOGO_TO_MEMBERSHIPS = "APPEND_LOGO_TO_MEMBERSHIPS";

export const fetchGolferProfile = (payload) => ({
  type: GOLFER_PROFILE_FETCH,
  payload,
});

export const fetchGolferProfileFailed = () => ({
  type: GOLFER_PROFILE_FETCH_FAILED,
});

export function fetchGolferProfileSuccess(payload) {
  const assocParams = {
    ghinNumber: payload[0].ghin,
    memberships: payload,
  };
  return (dispatch) => {
    dispatch({ type: GOLFER_PROFILE_FETCH_SUCCESS, payload });
    dispatch(fetchContactAssociations(assocParams));
  };
}

export const logoutGolferProfile = () => ({
  type: GOLFER_PROFILE_LOGOUT,
});

export function appendLogoToMemberships(payload) {
  return (dispatch) => {
    const associations = payload.associations;
    const golferMemberships = payload.memberships;
    const memberships = golferMemberships.map((membership) => {
      const foundAssociation = associations.find(
        (x) => Number(x.id) === Number(membership.association_id)
      );
      if (foundAssociation && foundAssociation.logo) {
        membership.logo = foundAssociation.logo;
      }
      return membership;
    });
    dispatch({ type: APPEND_LOGO_TO_MEMBERSHIPS, payload: memberships });
  };
}
